export const errors = {
    required: 'City required',
    minLength: 'Minimum length ',
    maxLength: 'Sorry, that\'s too long. Max length ',
    invalid: 'Sorry, that\'s an invalid entry'
};
